





















import { KafkaConf, KafkaConfig } from '@/services/datasource';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class KafkaConfDetail extends Vue {
  @Prop() kafkaConf!: any;
  
}
